import { IClientDto, ICPADto } from './dtos'
import { IClient, ICPA } from './models'

export const mapClientFromDto = ({ email, id, firstName, lastName }: IClientDto): IClient => ({
	id,
	email,
	firstName,
	lastName,
})

export const mapCPAFromDto = ({ email, id, firstName, lastName }: ICPADto): ICPA => ({
	id,
	email,
	firstName,
	lastName,
})
